
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { ProdConfig } from './blocks/config/prod.config';
import { TelerecourspnrAppModule } from './app.module';

ProdConfig();

if (module['hot']) {
    module['hot'].accept();
}

platformBrowserDynamic().bootstrapModule(TelerecourspnrAppModule);



// WEBPACK FOOTER //
// ./src/main/webapp/app/app.main.ts